import React from 'react';

interface LogoProps {
  size?: number;
  showText?: boolean;
  customLogoUrl?: string;
  siteName?: string;
  logoText1?: string;
  logoText2?: string;
  logoText3?: string;
}

export const Logo: React.FC<LogoProps> = ({
  size = 48,
  showText = true,
  customLogoUrl,
  siteName = 'KOMELIYA ÇANDÎ YA FRANSÎ-KURDÎ YA YVELINES',
  logoText1,
  logoText2,
  logoText3,
}) => {
  const finalLogoUrl = customLogoUrl || '/uploads/logo.png';

  return (
    <div className="flex items-center gap-2 sm:gap-3 select-none min-w-0">
      <div 
        style={{ width: `${size}px`, height: `${size}px` }}
        className="relative flex-shrink-0 rounded-full bg-white p-0.5 border border-[#D4AF37] shadow-[0_0_12px_rgba(212,175,55,0.4)] flex items-center justify-center group hover:scale-105 transition-transform duration-300 overflow-hidden"
      >
        {finalLogoUrl ? (
          <img
            src={finalLogoUrl}
            alt="Dernek Logosu"
            className="w-full h-full object-contain rounded-full"
            referrerPolicy="no-referrer"
          />
        ) : (
          <svg 
            viewBox="0 0 100 100" 
            className="w-full h-full text-[#D4AF37] drop-shadow-[0_0_8px_rgba(212,175,55,0.6)]"
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Outer Ring with decorative nodes */}
            <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="2.5" strokeDasharray="4 2" />
            <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="1.5" opacity="0.8" />
            
            {/* Kurdish Traditional Sun 21 Rays */}
            <g transform="translate(50,50)">
              {Array.from({ length: 21 }).map((_, i) => (
                <line
                  key={i}
                  x1="0"
                  y1="-18"
                  x2="0"
                  y2="-34"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  transform={`rotate(${(i * 360) / 21})`}
                />
              ))}
              {/* Center Golden Disk */}
              <circle cx="0" cy="0" r="14" fill="currentColor" opacity="0.95" />
              <circle cx="0" cy="0" r="8" fill="#081B16" />
              <circle cx="0" cy="0" r="4" fill="currentColor" />
            </g>
            
            {/* Wheat/Laurel Branch Arc */}
            <path
              d="M 18,50 A 32,32 0 0,0 82,50"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              opacity="0.6"
            />
          </svg>
        )}
      </div>

      {showText && (
        <div className="flex flex-col justify-center leading-none min-w-0">
          <span className="font-heading font-extrabold text-[10px] xs:text-[11px] sm:text-xs lg:text-sm tracking-tight sm:tracking-wide text-[#D4AF37] uppercase drop-shadow leading-tight truncate">
            {logoText1 || 'KOMELIYA ÇANDÎ YA'}
          </span>
          <span className="font-heading font-extrabold text-[9px] xs:text-[10px] sm:text-xs tracking-tight sm:tracking-wide text-white uppercase leading-tight mt-0.5 truncate">
            {logoText2 || 'FRANSÎ-KURDÎ YA YVELINES'}
          </span>
          {logoText3 && (
            <span className="font-heading font-semibold text-[8px] sm:text-[10px] tracking-tight sm:tracking-wide text-gray-300/90 uppercase leading-tight mt-0.5 hidden sm:block truncate">
              {logoText3}
            </span>
          )}
          <span className="text-[9px] font-medium text-emerald-400/90 italic tracking-wide mt-0.5 hidden lg:block truncate">
            Soreş û çand, rûmeta me ye
          </span>
        </div>
      )}
    </div>
  );
};
